import React from "react";
import PropTypes from "prop-types";
//Mui imports
import Grid from "@mui/material/Grid";
import makeStyles from "@mui/styles/makeStyles";
import { LogoLandingContainer } from "@limitless/portal";
import clonedeep from "lodash.clonedeep";
// Limitless imports
import { MultipleChoiceQuizTemplate } from "@limitless/content";
const multipleChoiceQuizPageStyles = makeStyles(theme => ({
  container: {
    position: "absolute",
    justifyContent: "center",
    top: "27%",
    overflowY: "auto",
    width: "70%",
    left: "10%",
    right: "15%",
    display: "grid",
    height: "auto",
    maxHeight: "calc(100vh - 250px)"
  },
  [theme.breakpoints.down("lg")]: {
    container: {
      top: "25%",
      bottom: "10%",
      paddingLeft: "5%"
    }
  },
  [theme.breakpoints.up("md")]: {
    container: {
      top: "25%",
      bottom: "10%",
      paddingLeft: "8%"
    }
  }
}));
const MultipleChoiceQuizPage = ({
  content,
  quizState,
  submitQuiz
}) => {
  const [mcQuizContent, setMcQuizContent] = React.useState(content);
  const classes = multipleChoiceQuizPageStyles();
  React.useEffect(() => setMcQuizContent(content), [content]);
  const updateSelectedMCQAnswer = (value, sectionIndex, mcQuizContent) => {
    const quizSections = clonedeep(mcQuizContent.sections);
    if (sectionIndex !== -1) {
      quizSections.find((quizItem, index) => {
        if (sectionIndex === index) {
          if (Reflect.getOwnPropertyDescriptor(quizItem, "wrongAnswer")) {
            quizItem.wrongAnswer = false;
          }
          quizItem.selectedAnswer = value;
        }
      });
      setMcQuizContent({
        ...mcQuizContent,
        sections: quizSections
      });
    }
  };
  return /*#__PURE__*/React.createElement(LogoLandingContainer, null, /*#__PURE__*/React.createElement(Grid, {
    className: classes.container
  }, /*#__PURE__*/React.createElement(MultipleChoiceQuizTemplate, {
    content: mcQuizContent,
    quizState: quizState,
    quizCtaClick: submitQuiz,
    disableQuizCta: true,
    isOnboardingView: true,
    handleAnswerChange: (index, sectionIndex) => {
      updateSelectedMCQAnswer(parseInt(index), sectionIndex, mcQuizContent);
    }
  })));
};
export default MultipleChoiceQuizPage;
MultipleChoiceQuizPage.propTypes = {
  content: PropTypes.object,
  submitQuiz: PropTypes.func.isRequired,
  quizState: PropTypes.object.isRequired
};